module.exports = "/_next/static/images/no-paying-fees-5ce7f0d80e91df3268fcbadf03decce5.svg";